import StatusBadge from './StatusBadge';
import './styles/GameCard.css';

interface GameCardProps {
  title: string;
  category: string;
  status: string | undefined;
  plays: number;
  icon: React.ReactNode;
  bgColor?: string;
  onClick?: () => void;
}

const GameCard: React.FC<GameCardProps> = ({
  title,
  category,
  status,
  plays,
  icon,
  bgColor = 'var(--color-card-teal)',
  onClick,
}) => (
  <div className="game-card" onClick={onClick}>
    <div className="game-card__info">
      <h4 className="game-card__title">{title}</h4>
      <p className="game-card__category">{category}</p>
      <div className="game-card__footer">
        <StatusBadge status={status} />
        <span className="game-card__plays">{plays} plays</span>
      </div>
    </div>
    <span
      className="game-card__type-icon"
      style={{ backgroundColor: bgColor }}
      aria-hidden="true"
    >
      {icon}
    </span>
  </div>
);

export default GameCard;
